/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AttributeNames; (function (AttributeNames) {
  const EXPRESS_TYPE = 'express.type'; AttributeNames["EXPRESS_TYPE"] = EXPRESS_TYPE;
  const EXPRESS_NAME = 'express.name'; AttributeNames["EXPRESS_NAME"] = EXPRESS_NAME;
})(AttributeNames || (AttributeNames = {}));

export { AttributeNames };
//# sourceMappingURL=AttributeNames.js.map
